var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0122 34.9134C39.9695 41.6048 36.1244 48.0073 32.2391 54.3841C31.0939 56.2609 29.2354 56.7841 27.5634 55.8475C25.9208 54.9256 25.3683 52.9426 26.4659 51.0914C30.333 44.5682 34.2805 38.0926 38.283 31.4561C40.211 32.6195 42.0512 33.7317 44.0122 34.917V34.9134Z",
    fill: "url(#paint0_linear_1418_113)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9902 49.3573C18.4317 42.4683 13.8731 35.5792 9.2085 28.5329C11.078 27.289 12.8304 26.1292 14.7475 24.8524C17.0158 28.2585 19.1268 31.6463 21.4719 34.8658C22.9134 36.8451 23.5024 38.8683 23.3524 41.2866C23.1878 43.928 23.3158 46.5914 23.3158 49.2439C23.2061 49.2805 23.1 49.3207 22.9902 49.3573Z",
    fill: "url(#paint1_linear_1418_113)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9377 17.8097C54.6146 21.8268 53.6268 24.9366 50.1841 27.0988C49.2402 27.6915 48.4792 27.8488 47.5572 27.2085C46.9097 26.7585 46.1816 26.4256 45.5487 25.961C44.4219 25.1378 42.4755 24.3256 42.395 23.3817C42.1792 20.7841 42.7938 18.011 45.2633 16.489C47.8755 14.8829 50.7182 13.65 53.495 12.2378C54.278 14.8427 54.2743 14.9085 52.0499 15.45C49.3938 16.0939 47.1365 17.239 46.0024 19.9171C45.5926 20.8866 45.106 22.039 46.3755 22.6097C47.6121 23.1658 48.0219 22.0463 48.3877 21.1134C49.3682 18.6293 51.578 18.2085 53.9341 17.8134L53.9377 17.8097Z",
    fill: "url(#paint2_linear_1418_113)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0378 45.9257V30.1903H32.4074C32.5208 33.1208 32.9488 35.9269 30.9952 38.561C29.2464 40.9208 27.8854 43.5696 26.3561 46.094C26.25 46.0391 26.1439 45.9842 26.0378 45.9257Z",
    fill: "url(#paint3_linear_1418_113)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6659 20.3854C26.3415 17.7293 25.211 15.5305 24.161 13.2915C23.9964 12.9403 24.0366 12.3 24.2598 11.9927C25.8183 9.83419 27.45 7.72688 29.1915 5.422C31.0427 7.8659 32.7951 10.1744 34.6537 12.6257C33.4098 15.1208 32.1512 17.6452 30.6549 20.6378C30.45 18.6366 30.0769 17.3086 31.6976 16.1122C33.3073 14.9269 33.1829 12.4976 31.7781 11.0964C30.4427 9.76468 28.2037 9.69517 26.8208 10.95C25.3134 12.311 24.9878 14.7257 26.5171 15.9696C27.922 17.1147 27.922 18.3476 27.6659 20.3891V20.3854Z",
    fill: "url(#paint4_linear_1418_113)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6694 29.1988C40.2621 28.2366 40.7304 27.4756 41.3341 26.4951C43.2292 27.6366 45.0219 28.7159 46.9646 29.8866C46.4158 30.8305 45.9438 31.6463 45.3767 32.6232C43.4194 31.4488 41.5828 30.3476 39.6658 29.1988H39.6694Z",
    fill: "url(#paint5_linear_1418_113)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7304 27.3036H26.6707C27.1207 23.828 27.5853 23.0963 29.2938 23.1146C30.7865 23.1329 31.4194 24.2012 31.7268 27.3036H31.7304Z",
    fill: "url(#paint6_linear_1418_113)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04153 19.5438C9.58909 20.8902 10.8879 22.017 12.3549 23.2938C11.1696 24.0731 9.94763 24.8743 8.70738 25.6865C8.15494 23.8719 7.65007 22.2292 7.06836 20.3158C7.30616 20.1292 7.74885 19.778 8.04153 19.5438Z",
    fill: "url(#paint7_linear_1418_113)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84522 17.1365C6.28912 17.5134 5.84644 17.817 5.23912 18.2304C4.75986 17.517 4.3062 16.8475 3.85254 16.1743C4.99644 15.4036 5.994 15.7256 6.84522 17.1402V17.1365Z",
    fill: "url(#paint8_linear_1418_113)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2207 12.3512C29.6707 12.9768 30.161 13.3646 30.1098 13.6573C30.0512 14.0012 29.5317 14.4731 29.1915 14.4914C28.8988 14.5061 28.3646 13.9829 28.328 13.6536C28.2951 13.339 28.7671 12.9731 29.2207 12.3475V12.3512Z",
    fill: "url(#paint9_linear_1418_113)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1418_113",
    x1: 43.1707,
    y1: 34.939,
    x2: 24.878,
    y2: 53.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51767F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1418_113",
    x1: 22.7171,
    y1: 28.2876,
    x2: 5.07103,
    y2: 42.5581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51767F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1418_113",
    x1: 44.8307,
    y1: 27.5936,
    x2: 56.859,
    y2: 19.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1418_113",
    x1: 32.2251,
    y1: 32.4197,
    x2: 22.1415,
    y2: 38.1748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51767F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1418_113",
    x1: 26.2861,
    y1: 20.6103,
    x2: 37.7081,
    y2: 13.7113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1418_113",
    x1: 39.878,
    y1: 29.0854,
    x2: 46.8292,
    y2: 29.6341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1418_113",
    x1: 26.8178,
    y1: 24.885,
    x2: 31.6357,
    y2: 25.2708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1418_113",
    x1: 7.22208,
    y1: 22.1403,
    x2: 12.2719,
    y2: 22.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1418_113",
    x1: 4.48134,
    y1: 18.226,
    x2: 6.56807,
    y2: 16.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1418_113",
    x1: 28.7019,
    y1: 14.4879,
    x2: 30.4288,
    y2: 13.2392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD264"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88e3993d20c966e8f9bd4bfba75dcf02.svg";
export { ForwardRef as ReactComponent };